/* tslint:disable */

declare var Object: any;
export interface NewsFeedInterface {
  "id"?: number;
}

export class NewsFeed implements NewsFeedInterface {
  "id": number;
  constructor(data?: NewsFeedInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `NewsFeed`.
   */
  public static getModelName() {
    return "NewsFeed";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of NewsFeed for dynamic purposes.
  **/
  public static factory(data: NewsFeedInterface): NewsFeed{
    return new NewsFeed(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'NewsFeed',
      plural: 'NewsFeeds',
      path: 'NewsFeeds',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/NewsFeed.ts